(($) => {
	'use strict';

	function init() {
		const pageHeaderInputs = $('.page-header-inputs');
		$('input, select', pageHeaderInputs).on('change', function(e){onPageHeaderInputsChange(e,false);});
		$('input[type="text"], input[type="search"]', pageHeaderInputs).on('keydown', onPageHeaderInputTextKeyDown);
		$('input[type="search"]').on("keydown",function(event){
			event = event || window.event; // Handle older browsers
            var key = event.key || event.keyCode;

			if (key === "Enter" || key === 13) {
				onPageHeaderInputsChange(event,true);
			}
		})
	};
	
	function onPageHeaderInputsChange(e,isEnter) {
		
		const $form = $(e.currentTarget.form);
		const dataType=$form.attr("data-type");
		
		if(dataType=="implicit-search"){
			e.preventDefault();
			if(isEnter){
				var rows = $('.table>tbody>tr');
				var filterValue=$('.page-header-inputs-search__field').val();
				// var filterValueSplitted=filterValue.split(" ");
				rows.each((i,row)=>{
					var showRow = false;
					$(row).find('td').each((j,col)=>{
						if($(col).attr("data-label")!="" && $(col).attr("data-label")!=undefined){
							var cellValue = $(col).text().toLowerCase();
							// for(var l=0;filterValueSplitted!=undefined && l<filterValueSplitted.length;l++)
							if (cellValue.includes(filterValue.toLowerCase())) {
								showRow = true;
							}
						}
					});

					if (showRow) {
						$(row).css("display",""); // Show row if any cell matches filter
					} else {
						$(row).css("display","none"); // Hide row if no cell matches filter
					}
				});
			}
		}else if(dataType=="custom-search"){
			var filterSelect=$form.find("#logs-page-filter-type-input");
			var selectedVal=filterSelect.find(":selected").val();
			
			$(".new-added-divs").removeClass("d-block").removeClass("d-flex");
			$(".new-added-divs").addClass("d-none");

			$("#fromDate").attr("name","");
			$("#toDate").attr("name","");
			$("#incidentType").attr("name","");
			$(".page-header-inputs-search__field").attr("name","q");

			if(selectedVal!="incidentType" && selectedVal!="byDate"){
				$("#new-added-divs-parent").removeClass("d-flex").addClass("d-none");
				$(".page-header-inputs__search").removeClass("d-none").addClass("d-block");
				if(isEnter) $form.get(0).submit();
			}
			
			if(selectedVal=="incidentType" || selectedVal=="byDate"){
				$("#new-added-divs-parent").removeClass("d-none").addClass("d-flex");
				$(".page-header-inputs__search").removeClass("d-block").addClass("d-none");
				$(".page-header-inputs-search__field").attr("name","");

				$("#"+selectedVal+"Div").removeClass("d-none").addClass($("#"+selectedVal+"Div").attr("type")=="flex"?"d-flex":"d-block");
				
				if(selectedVal=="incidentType"){
					window.parent.updateHiddenSelect2($("#incidentTypeDiv"));
					$("#incidentType").attr("name","incidentType");
				}

				if(selectedVal=="byDate"){
					$("#fromDate").attr("name","fromDate");
					$("#toDate").attr("name","toDate");
				}
			}
		}else{
			$('input[type="checkbox"]', $form).each((i, el) => {
				$('input[data-name="' + el.name + '"]', $form).val(el.checked ? el.value : "");
				el.setAttribute('disabled', 'disabled');
			});
			$('input[type="text"], input[type="hidden"], input[type="search"], select', $form).each((i, el) => {
				if (el.value === "" || (!$(el).is(":visible") && el.type != 'hidden')) {
					el.setAttribute('disabled', 'disabled');
				}
			});
			$form.get(0).submit();
		}
	};

	function onPageHeaderInputTextKeyDown(e) {
		const isEnter = e.which === '13';
		const noModifier = e.metaKey && !e.altKey && !e.shiftKey && !e.ctrlKey;
		
		if (isEnter && noModifier) {
			onPageHeaderInputsChange(e,false);
		}
	}

	function onRowsPerPageChange() {
		var url = new URL(window.location.href);
		url.searchParams.set('gdPerPage', this.value);
		url.searchParams.set('count', this.value);
		url.searchParams.set('perPage', this.value);
		url.searchParams.set('page', '1');
		window.location.href = url.toString();
	}

	$(init);
	$(function() {
		$('.js-rows-per-page').on('change', onRowsPerPageChange);
	});
})(jQuery);
